import { nth } from "@Utils";
import moment from "moment";

/**
 * This is a barrel file.
 */
export * from "./prepareColumnData";

// ** Label Helpers

export const yAxisLabelFormatterHandler = (value: number): string => {
    if (!value) {
        return "0m";
    } else {
        const hours: number = Math.floor(value / 3600);
        const mins: number = Math.floor((value % 3600) / 60);
        const secs: number = Math.floor(value % 60);
        if (hours === 0 && mins === 0) return "< 1m";
        return String((hours > 0 ? hours + "h " : "") + mins + "m " + secs + "s");
    }
};

export const smoothnessYAxisLabelFormatterHandler = (value: number) => {
    return value + nth(value).toString();
};

// ** Tooltip Helpers

export const smoothnessTooltipFormatter = (value, yField: string) => {
    const val = Math.floor(value[yField]);
    if (!val) {
        return { name: "Smoothness", value: "0" + nth(0) + " percentile" };
    } else {
        return {
            name: yField,
            value: val + nth(Math.floor(val)) + " percentile",
        };
    }
};

export const tooltipFormatter = (value, yField: string) => {
    const yVal = value[yField];
    if (!yVal) {
        return { name: "Duration", value: "0m" };
    } else {
        const hours: number = Math.floor(yVal / 3600);
        const mins: number = Math.floor((yVal % 3600) / 60);
        const secs: number = Math.floor(yVal % 60);

        if (hours === 0 && mins === 0) return { name: yField, value: "< 1m" };

        return {
            name: yField,
            value: String((hours > 0 ? hours + "h" + " " : "") + mins + "m " + secs + "s"),
        };
    }
};

export const tooltipTitle = (title: string) => {
    return moment(title).format("LLLL");
};
